var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
}
var FormErrorScroller = /** @class */ (function (_super) {
    __extends(FormErrorScroller, _super);
    function FormErrorScroller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        return _this;
    }
    FormErrorScroller.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isSubmitting &&
            !this.props.isSubmitting &&
            !this.props.isValid) {
            var form = this.ref.current ? this.ref.current.parentElement : null;
            if (!form) {
                return;
            }
            var firstInvalid = form.querySelector('[data-invalid]');
            if (firstInvalid && !isElementInViewport(firstInvalid)) {
                firstInvalid.scrollIntoView();
            }
        }
    };
    FormErrorScroller.prototype.render = function () {
        return React.createElement("div", { ref: this.ref });
    };
    return FormErrorScroller;
}(React.Component));
export { FormErrorScroller };
//# sourceMappingURL=FormErrorScroller.js.map